// extracted by mini-css-extract-plugin
export default {"moreInfoRows":"more-information-module__moreInfoRows___CGOjt","name":"more-information-module__name___VLPMH","text":"more-information-module__text___KMFms"};